import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  knownByOtherNames: () => i18n.t(i18nKeys.alias__history__knownByOtherNames),
  listAllAliases: () => i18n.t(i18nKeys.alias__history__listAllAliases),
  noAliasToggle: () => i18n.t(i18nKeys.alias__history__noAliasToggle),
  hasAliasToggle: () => i18n.t(i18nKeys.alias__history__hasAliasToggle),
  addAnotherAlias: () => i18n.t(i18nKeys.alias__history__addAnotherAlias),
  continue: () => i18n.t(i18nKeys.alias__history__continue),
}
